import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectorRef, Directive, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material/expansion';
import { ResourceItemComposerDirective, ResourceItemData } from '@klickdata/core/resource-item';
import { takeUntil, tap } from 'rxjs';
import { MaterialManagerCoreService } from './material-manager-core.service';
import { CdkDropList } from '@angular/cdk/drag-drop';
import { MatMenuTrigger } from '@angular/material/menu';

@Directive()
export abstract class MaterialItemComposerDirective extends ResourceItemComposerDirective implements OnInit {
    @ViewChild('expansionPanel') expansionPanel: MatExpansionPanel;
    @ViewChild('bundleItemsList') bundleItemsList: CdkDropList<any>;
    @ViewChild('otherToolsMenuTrigger') otherToolsMenuTrigger: MatMenuTrigger;
    @ViewChild('addNewBlockMenuTrigger') addNewBlockMenuTrigger: MatMenuTrigger;
    @Output() onDisableSorting = new EventEmitter<boolean>();
    @Output() onDelete = new EventEmitter<number>();
    @Output() onCopy = new EventEmitter<ResourceItemData>();
    @Output() onTranslate = new EventEmitter<{ language_id: number; indices: number[] }>();
    @Output() onRegenerate = new EventEmitter<number>();
    @Output() onDuplicate = new EventEmitter<number>();
    @Output() onCreateTestFromMaterial = new EventEmitter<number>();
    @Output() onIsItemsProcessing = new EventEmitter<boolean>();
    @Output() onClearEditMode = new EventEmitter<boolean>();
    @Output() onSelection = new EventEmitter<SelectionModel<any>>();
    @Output() onPerformSubmit = new EventEmitter<{ eager: string }>();
    @Output() onAddNewBlock: EventEmitter<{ index: number; blockType: string }> = new EventEmitter<{
        index: number;
        blockType: string;
    }>();
    @Input() isEditInBottomSheet: boolean;
    constructor(
        protected cdRef: ChangeDetectorRef,
        protected parentFormDirective: FormGroupDirective,
        protected materialManagerCoreService: MaterialManagerCoreService
    ) {
        super(parentFormDirective);
    }
    ngOnInit(): void {
        this.selection?.changed
            .pipe(
                takeUntil(this.destroy),
                tap(() => this.cdRef.markForCheck())
            )
            .subscribe();
        this.itemForm
            .get('item_visibility')
            .valueChanges.pipe(takeUntil(this.destroy))
            .subscribe((value) => {
                this.itemForm.get('item_visibility').markAsDirty();
                this.itemForm.markAsDirty();
            });
        this.itemForm
            .get('headline_visibility')
            .valueChanges.pipe(takeUntil(this.destroy))
            .subscribe((value) => {
                this.itemForm.get('headline_visibility').markAsDirty();
                this.itemForm.markAsDirty();
            });
    }

    deleteItem(index: number): void {
        this.onDelete.emit(index);
    }
    copyItem(itemData: ResourceItemData): void {
        this.onCopy.emit(itemData);
    }
    translateItem(itemData: { language_id: number; indices: number[] }): void {
        this.onTranslate.emit(itemData);
    }
    regenerateItem(index: number): void {
        this.onRegenerate.emit(index);
    }
    duplicateItem(index: number): void {
        this.onDuplicate.emit(index);
    }

    get areItemsProcessing(): boolean {
        return this.materialManagerCoreService.areItemsProcessing.value;
    }

    get selection(): SelectionModel<any> {
        return this.materialManagerCoreService.selection;
    }
}
